module.exports = __webpack_public_path__ + "static/media/magazineTupp_02_thumb_hover.c47229ce.png";